export const SHARE_RECOMMENDATIONS_FEEDBACK_MODAL_EVENT = 'petition_manage_recommendations_feedback_click';
